import { CheckCircleIcon, InfoIcon, SpinnerIcon, WarningIcon, XCircleIcon } from "@phosphor-icons/react"
import { Toaster as Sonner, type ToasterProps } from "sonner"

// Theme is passed in by the app (resolved from the local preference); no next-themes dependency.
// Toasts float over content, so they are frost (docs/DESIGN.md §1); the close button sits inside the
// toast on the right instead of hanging off its corner.
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      icons={{
        success: <CheckCircleIcon className="size-4 text-gain" />,
        info: <InfoIcon className="size-4 text-foreground" />,
        warning: <WarningIcon className="size-4 text-amber" />,
        error: <XCircleIcon className="size-4 text-loss" />,
        loading: <SpinnerIcon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--frost-bg)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--frost-edge)",
          "--border-radius": "0.75rem",
          "--toast-close-button-transform": "none",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast:
            "cn-toast pr-11! shadow-[var(--frost-shadow)]! backdrop-blur-[20px] backdrop-saturate-[1.6] text-[0.8125rem]!",
          title: "font-medium!",
          description: "text-muted-foreground!",
          closeButton:
            "left-auto! right-2! top-1/2! -translate-y-1/2! translate-x-0! size-6! border-0! bg-transparent! text-muted-foreground! hover:bg-surface-2! hover:text-foreground!",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
